// extracted by mini-css-extract-plugin
module.exports = {"variantGridBody":"VariantGrid_variantGridBody__13oQf","title":"VariantGrid_title__3hPNG"};